// src/pages/PropertyDetail/PropertyDetail.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import convertPrice from "../../utils/convertAmount";
import {
  FiCheckCircle,
  FiMaximize2,
  FiDroplet,
  FiMapPin,
  FiHome,
} from "react-icons/fi";
import { FaBed } from "react-icons/fa";
import AgentStickyCard from "./AgentStickyCard";
import PropertyGallery from "./PropertyGallery";
import PropertyCard from "./PropertyCard";
import "./PropertyDetail.css";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";

export default function PropertyDetail() {
  const { slug } = useParams();
  const [listing, setListing] = useState({});

  const [similarProp, setSiimilarProp] = useState([]);

  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const getDetail = async () => {
    const data = {
      url: apis().getListingDetail + "?id=" + id,
    };
    const result = await httpAction(data);
    if (result?.status) {
      setListing(result?.listing);
    }
  };
  useEffect(() => {
    getDetail();
  }, [id]);

  const similar = useMemo(
    () => [
      {
        id: 201,
        title: "3 Bed Family Apartment – Near Park",
        location: "Bahria Town, Lahore",
        type: "Apartment",
        price: "PKR 2.4 Crore",
        beds: 3,
        baths: 3,
        area: "1,450 sqft",
        badge: "Featured",
        image:
          "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1400&q=80",
      },
      {
        id: 202,
        title: "Luxury 10 Marla House – Corner & Lawn",
        location: "DHA Phase 5, Lahore",
        type: "House",
        price: "PKR 7.8 Crore",
        beds: 4,
        baths: 5,
        area: "10 Marla",
        badge: "New",
        image:
          "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1400&q=80",
      },
      {
        id: 203,
        title: "High-Rise Studio – Investment Friendly",
        location: "MM Alam, Lahore",
        type: "Apartment",
        price: "PKR 1.6 Crore",
        beds: 1,
        baths: 1,
        area: "520 sqft",
        badge: "Hot",
        image:
          "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1400&q=80",
      },
    ],
    []
  );

  const getSimilar = async () => {
    const data = {
      url: apis().getListingSimilar + "?type=" + listing?.data?.type,
    };

    const result = await httpAction(data);
    if (result?.status) {
      setSiimilarProp(result?.list);
    }
  };

  useEffect(() => {
    getSimilar();
  }, [listing]);

  return (
    <div className="pd">
      <PropertyGallery
        images={listing?.data?.images?.map(
          (item) => apis().localUrl + item?.url
        )}
        price={`PKR: ${convertPrice(listing?.data?.price)}`}
        title={listing?.data?.title}
        location={listing?.data?.location}
        badge="Verified"
      />

      <div className="container">
        <div className="pd__crumbs">
          <Link className="pd__crumb" to="/listing">
            ← Back to Properties
          </Link>
          <span className="pd__crumbMuted">Slug: {slug}</span>
        </div>

        <div className="pd__layout">
          {/* Main */}
          <main className="pd__main">
            {/* Key strip */}
            <section className="pd__strip">
              <div className="pd__kv">
                <span className="pd__k">Status</span>
                <span className="pd__v">
                  <FiCheckCircle /> {listing?.data?.status}
                </span>
              </div>
              <div className="pd__kv">
                <span className="pd__k">Property ID</span>
                <span className="pd__v">{listing?._id?.substring(0, 6)}</span>
              </div>
              <div className="pd__kv">
                <span className="pd__k">Type</span>
                <span className="pd__v">
                  <FiHome /> {listing?.data?.type}
                </span>
              </div>
              <div className="pd__kv">
                <span className="pd__k">Beds</span>
                <span className="pd__v">
                  <FaBed /> {listing?.data?.bed}
                </span>
              </div>
              <div className="pd__kv">
                <span className="pd__k">Baths</span>
                <span className="pd__v">
                  <FiDroplet /> {listing?.data?.bath}
                </span>
              </div>
              <div className="pd__kv">
                <span className="pd__k">Area</span>
                <span className="pd__v">
                  <FiMaximize2 /> {listing?.data?.size}
                </span>
              </div>
            </section>

            {/* Description */}
            <section className="pd__panel">
              <h2 className="pd__h">Overview</h2>
              <p className="pd__p">{listing?.data?.des}</p>

              <div className="pd__locLine">
                <FiMapPin />
                <span>{listing?.data?.city}</span>
              </div>
            </section>

            {/* Amenities */}
            <section className="pd__panel">
              <h2 className="pd__h">Amenities</h2>
              <div className="pd__amenities">
                {listing?.data?.ammenities?.map((a) => (
                  <div className="pd__amenity" key={a}>
                    <FiCheckCircle /> {a}
                  </div>
                ))}
              </div>
            </section>

            {/* Map placeholder */}
            <section className="pd__panel">
              <h2 className="pd__h">Location</h2>
              <div className="pd__map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.2086192374027!2d74.23464607527912!3d31.353221855381836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391901e838ff5401%3A0xf80e2592944e121f!2sHafiz%20Brothers%20builders%20and%20developers!5e0!3m2!1sen!2s!4v1767880202328!5m2!1sen!2s"
                  width="100%"
                  height="100%"
                  // style="border:0;"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </section>
          </main>

          {/* Sticky agent */}
          <AgentStickyCard agent={listing?.user} id={listing?._id} />
        </div>

        {/* Similar */}
        <section className="pd__panel pd_full">
          <h2 className="pd__h">Similar Properties</h2>
          <div className="pd__similarGrid">
            {similarProp?.map((x, index) => (
              <PropertyCard key={x.id} item={x} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
